/**
 * The theme runs on almost no JavaScript by design — the system has no
 * carousels, modals or reveal animations. This covers the two things
 * Liquid alone cannot: the mobile drawer, and swapping the product image
 * when a variant is chosen.
 */
(function () {
  "use strict";

  /* ── Mobile drawer ─────────────────────────────────────────────────── */
  var drawer = document.querySelector("[data-drawer]");
  var openBtn = document.querySelector("[data-drawer-open]");
  var closeBtn = document.querySelector("[data-drawer-close]");

  function setDrawer(open) {
    if (!drawer) return;
    drawer.hidden = !open;
    if (openBtn) openBtn.setAttribute("aria-expanded", String(open));
    document.documentElement.style.overflow = open ? "hidden" : "";
    if (open && closeBtn) closeBtn.focus();
    else if (!open && openBtn) openBtn.focus();
  }

  if (openBtn) openBtn.addEventListener("click", function () { setDrawer(true); });
  if (closeBtn) closeBtn.addEventListener("click", function () { setDrawer(false); });
  // Any link inside navigates away, so the drawer closes with the click
  // rather than reacting to the page change afterwards.
  if (drawer) {
    drawer.addEventListener("click", function (e) {
      if (e.target.closest("a")) setDrawer(false);
    });
  }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer && !drawer.hidden) setDrawer(false);
  });

  /* ── Variant selection ─────────────────────────────────────────────── */
  var form = document.getElementById("product-form");
  if (!form) return;

  var dataEl = document.querySelector("[data-variant-json]");
  if (!dataEl) return;

  var variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (err) {
    return;
  }

  var idInput = form.querySelector("[data-variant-id]");
  var priceEl = document.querySelector("[data-variant-price]");
  var addBtn = form.querySelector("[data-add-button]");
  var mediaEl = document.querySelector("[data-variant-media]");

  function selectedOptions() {
    return Array.prototype.map.call(
      form.querySelectorAll("[data-option-index]"),
      function (group) {
        var checked = group.querySelector("input:checked");
        return checked ? checked.value : null;
      }
    );
  }

  function matchVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var hit = true;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] !== null && v.options[j] !== opts[j]) { hit = false; break; }
      }
      if (hit) return v;
    }
    return null;
  }

  function update() {
    var variant = matchVariant(selectedOptions());

    if (!variant) {
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.dataset.unavailable || "Unavailable";
      }
      return;
    }

    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.innerHTML = variant.price_html;
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available
        ? addBtn.dataset.add || "Add to bag"
        : addBtn.dataset.soldOut || "Sold out";
    }
    if (mediaEl && variant.image) {
      mediaEl.src = variant.image.src;
      mediaEl.srcset = "";
    }

    // Keep the URL shareable — a sent link should open on the same variant.
    if (window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url);
    }
  }

  form.addEventListener("change", function (e) {
    if (e.target.matches("input[type=radio]")) update();
  });

  /* ── Product gallery thumbnails ────────────────────────────────────── */
  var thumbs = document.querySelectorAll("[data-thumb]");
  Array.prototype.forEach.call(thumbs, function (btn) {
    btn.addEventListener("click", function () {
      if (!mediaEl) return;
      mediaEl.src = btn.dataset.thumb;
      mediaEl.srcset = "";
      Array.prototype.forEach.call(thumbs, function (b) {
        b.setAttribute("aria-current", String(b === btn));
      });
    });
  });
})();
